export default class ExperienceItemModel {
    constructor(title, subtitle, date, link) {
        this.title = title;
        this.subtitle = subtitle;
        this.date = date;
        this.link = link;

    }
}